module.exports = __webpack_public_path__ + "assets/img/LTC010.554a30ca.png";